import React from "react";
import ResourceEditor from "./ResourceEditor";

const fmtMinutes = (mins) => {
  if (!mins) return "—";
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h && m) return `${h}h${String(m).padStart(2, "0")}`;
  if (h) return `${h}h`;
  return `${m} min`;
};

const PricingTiersAdmin = () => (
  <ResourceEditor
    resource="pricing_tiers"
    title="Grille tarifaire par volume horaire"
    subtitle="Chaque ligne définit le prix annuel selon le volume hebdomadaire total de l'élève. La tranche appliquée est la plus élevée dont la durée ≤ au volume hebdo de l'élève."
    fields={[
      { key: "weeklyMinutes", label: "Volume hebdomadaire (en minutes)", type: "number", placeholder: "60" },
      { key: "label", label: "Libellé affiché", placeholder: "1h hebdomadaire" },
      { key: "yearPrice", label: "Tarif annuel (€)", type: "number", placeholder: "320" },
      { key: "trimesterPrice", label: "Tarif trimestriel (€)", type: "number", placeholder: "120" },
    ]}
    emptyItem={{ weeklyMinutes: 60, label: "", yearPrice: 0, trimesterPrice: 0 }}
    renderPreview={(t) => (
      <div className="min-w-0">
        <div className="font-serif-display text-stone-800">{t.label || fmtMinutes(t.weeklyMinutes)}</div>
        <div className="text-stone-500 text-sm">
          {fmtMinutes(t.weeklyMinutes)} hebdo · <span className="text-deep-rose">{t.yearPrice} € / an</span>
          {t.trimesterPrice ? <span> · {t.trimesterPrice} € / trimestre</span> : null}
        </div>
      </div>
    )}
  />
);

export default PricingTiersAdmin;
